// Maps each SimulatedDataPullSource to the rejection codes it can produce on a no-hit.
// When adding a new data source, append its entry here alongside the BE enum value.
export const SIMULATED_NO_HIT_CODES = {
  coverageVerifier: [5003] // NEEDCV
};

export const getSimulatedCodes = (noHitDataPulls = []) =>
  new Set(noHitDataPulls.flatMap((src) => SIMULATED_NO_HIT_CODES[src] ?? []));
